/* LAMORE storefront interactions — small, dependency-free. */
(function () {
  'use strict';

  function goToSlide(box, mediaId) {
    var track = box.querySelector('[data-lm-track]');
    if (!track || !track.offsetParent) return;
    var slide = track.querySelector('.lm-slide[data-media-id="' + mediaId + '"]');
    if (!slide) return;
    var index = Array.prototype.indexOf.call(track.children, slide);
    track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
  }

  function initTrack(box) {
    var track = box.querySelector('[data-lm-track]');
    var dots = box.querySelectorAll('[data-lm-dots] span');
    if (!track || !dots.length) return;
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
        ticking = false;
      });
    }, { passive: true });
  }

  function setMain(box, src, alt, mediaId) {
    goToSlide(box, mediaId);
    var img = box.querySelector('.lm-main-img');
    if (!img || !src) return;
    if (img.getAttribute('data-current') === String(mediaId)) return;
    img.style.opacity = '0';
    var next = new Image();
    next.onload = function () {
      img.removeAttribute('srcset');
      img.src = src;
      if (alt) img.alt = alt;
      img.setAttribute('data-current', String(mediaId));
      img.style.opacity = '1';
    };
    next.src = src;
    box.querySelectorAll('[data-lm-thumb]').forEach(function (t) {
      t.setAttribute('aria-current', String(t.getAttribute('data-media-id') === String(mediaId)));
    });
  }

  function addToBag(id, quantity) {
    var headerEl = document.querySelector('#header-component');
    var headerSection = headerEl && headerEl.closest('.shopify-section');
    var headerId = headerSection ? headerSection.id.replace('shopify-section-', '') : '';
    var sectionIds = ['cart-drawer-section'];
    if (headerId) sectionIds.push(headerId);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: quantity }], sections: sectionIds.join(','), sections_url: window.location.pathname })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function (res) {
        var s = res.sections || {};
        var target = document.getElementById('shopify-section-cart-drawer-section');
        if (!target || !s['cart-drawer-section']) throw new Error('no drawer');
        var tmp = document.createElement('div');
        tmp.innerHTML = s['cart-drawer-section'];
        var fresh = tmp.querySelector('#shopify-section-cart-drawer-section') || tmp;
        target.innerHTML = fresh.innerHTML;
        if (headerId && s[headerId]) {
          var h = document.createElement('div');
          h.innerHTML = s[headerId];
          var nb = h.querySelector('[aria-controls="cart-drawer"]');
          var ob = document.querySelector('#header-component [aria-controls="cart-drawer"]');
          if (nb && ob) ob.innerHTML = nb.innerHTML;
        }
        return new Promise(function (resolve) {
          setTimeout(function () {
            var drawer = document.getElementById('cart-drawer');
            if (drawer && typeof drawer.open === 'function') drawer.open();
            else window.location.href = '/cart';
            resolve();
          }, 120);
        });
      });
  }

  function selectVariant(box, input) {
    var idField = box.querySelector('[data-lm-id]');
    var add = box.querySelector('[data-lm-add]');
    var label = box.querySelector('[data-lm-add-label]');
    var name = box.querySelector('[data-lm-color-name]');
    var price = box.querySelector('[data-lm-price]');
    var available = input.getAttribute('data-available') === 'true';
    if (idField) idField.value = input.value;
    if (name) name.textContent = input.getAttribute('data-title');
    if (price) price.textContent = input.getAttribute('data-price');
    if (add) add.disabled = !available;
    if (label) label.textContent = available ? 'Add to Bag' : 'Sold Out';
    setMain(box, input.getAttribute('data-src'), input.getAttribute('data-title'), input.getAttribute('data-media-id'));
    document.querySelectorAll('[data-lm-sticky-price]').forEach(function (el) { el.textContent = input.getAttribute('data-price'); });
    document.querySelectorAll('[data-lm-sticky-variant]').forEach(function (el) { el.textContent = input.getAttribute('data-title'); });
    syncTiles(input.getAttribute('data-color'));
    if (document.querySelector('main[data-template^="product"]') && window.history.replaceState) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', input.value);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* ignore */ }
    }
  }

  function initBox(box) {
    initTrack(box);
    box.querySelectorAll('[data-lm-variant]').forEach(function (input) {
      input.addEventListener('change', function () { selectVariant(box, input); });
    });
    box.querySelectorAll('[data-lm-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setMain(box, btn.getAttribute('data-src'), btn.getAttribute('data-alt'), btn.getAttribute('data-media-id'));
      });
    });
    var qty = box.querySelector('[data-lm-qty-input]');
    box.querySelectorAll('[data-lm-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = parseInt(qty.value, 10) || 1;
        v = Math.min(10, Math.max(1, v + parseInt(btn.getAttribute('data-lm-qty'), 10)));
        qty.value = v;
      });
    });
    var form = box.querySelector('form.lm-form');
    var add = box.querySelector('[data-lm-add]');
    if (form && add) {
      form.addEventListener('submit', function (ev) {
        if (!window.fetch) return;
        ev.preventDefault();
        var l = box.querySelector('[data-lm-add-label]');
        var idField = box.querySelector('[data-lm-id]');
        add.disabled = true;
        add.setAttribute('aria-busy', 'true');
        if (l) l.textContent = 'Adding…';
        addToBag(parseInt(idField.value, 10), parseInt(qty.value, 10) || 1)
          .then(function () {
            if (l) l.textContent = 'Added';
            setTimeout(function () { if (l) l.textContent = 'Add to Bag'; add.disabled = false; }, 1600);
          })
          .catch(function () { form.submit(); })
          .finally(function () { add.removeAttribute('aria-busy'); });
      });
    }
  }

  function chooseColor(color) {
    var box = document.querySelector('[data-lm-buybox]');
    if (!box) return;
    var input = box.querySelector('[data-lm-variant][data-color="' + color + '"]');
    if (input && !input.disabled) { input.checked = true; selectVariant(box, input); }
  }

  function syncTiles(color) {
    document.querySelectorAll('.lm-shade[data-lm-pick]').forEach(function (t) {
      var on = t.getAttribute('data-lm-pick') === color;
      t.classList.toggle('is-selected', on);
      t.setAttribute('aria-current', on ? 'true' : 'false');
    });
  }

  function initSound() {
    document.querySelectorAll('[data-lm-sound]').forEach(function (btn) {
      var video = btn.parentNode.querySelector('video');
      if (!video) { btn.hidden = true; return; }
      btn.addEventListener('click', function () {
        video.muted = !video.muted;
        if (!video.muted) video.play();
        btn.setAttribute('aria-pressed', String(!video.muted));
        btn.setAttribute('aria-label', video.muted ? 'Turn sound on' : 'Turn sound off');
      });
    });
  }

  function initTiles() {
    var checked = document.querySelector('[data-lm-buybox] [data-lm-variant]:checked');
    if (checked) syncTiles(checked.getAttribute('data-color'));
    document.querySelectorAll('[data-lm-pick]').forEach(function (a) {
      a.addEventListener('click', function () { chooseColor(a.getAttribute('data-lm-pick')); });
    });
  }

  function initReveal() {
    var els = document.querySelectorAll('.lm-reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initSticky() {
    var bar = document.querySelector('[data-lm-sticky]');
    if (!bar) return;
    var hero = document.querySelector('[data-lm-hero]');
    var buy = document.querySelector('[data-lm-buybox]');
    var pastHero = !hero;
    var buyVisible = false;
    function update() { bar.classList.toggle('is-visible', pastHero && !buyVisible); }
    if (!('IntersectionObserver' in window)) return;
    if (hero) new IntersectionObserver(function (e) { pastHero = !e[0].isIntersecting; update(); }).observe(hero);
    if (buy) new IntersectionObserver(function (e) { buyVisible = e[0].isIntersecting; update(); }, { threshold: 0.05 }).observe(buy);
    var btn = bar.querySelector('[data-lm-sticky-btn]');
    if (btn && buy) {
      btn.addEventListener('click', function (ev) {
        ev.preventDefault();
        var form = buy.querySelector('form.lm-form');
        var add = buy.querySelector('[data-lm-add]');
        if (form && add && !add.disabled && form.requestSubmit) {
          var label = btn.textContent;
          btn.textContent = 'Adding…';
          form.requestSubmit(add);
          setTimeout(function () { btn.textContent = label; }, 1800);
        } else {
          buy.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-lm-buybox]').forEach(initBox);
    initTiles();
    initSound();
    initReveal();
    initSticky();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
